import * as React from 'react';
import { memo, useMemo, useRef, useState } from 'react';

import { useIsomorphicLayoutEffect } from '@lib/hooks'
import { buildSvgPath } from '@utils/index'

import BlueAreaSvg from './SvgChart/BlueAreaSvg';
import RedAreaSvg from './SvgChart/RedAreaSvg';

const PriceChart = (props) => {
  const { riseAndFall, data, height, style = {} } = props
  const ref = useRef();
  const [width, setWidth] = useState()
  const { pathline, patharea } = useMemo(() => {
    return buildSvgPath(data, { width: width, height: height })
  }, [width, data])
  useIsomorphicLayoutEffect(() => {
    const resizeObserver = new ResizeObserver(([entry]) => {
      const { contentBoxSize: [{ inlineSize }] } = entry;
      console.log(inlineSize, 'inlineSize')
      const w = inlineSize > 248 ? 248 : inlineSize
      setWidth(w)
    });
    resizeObserver.observe(ref.current);
    return () => {
      resizeObserver.unobserve(ref.current)
    }
  }, [])

  if (!data || pathline.indexOf('NaN') !== -1) return <div ref={ref} style={{ fontSize: 0 }} />

  return (
    <div ref={ref} style={{ fontSize: 0 }}>
      {
        riseAndFall > 0
          ? (
            <BlueAreaSvg pathline={pathline} patharea={patharea} height={height} width={width} style={style}/>
            )
          : (
            <RedAreaSvg pathline={pathline} patharea={patharea} height={height} width={width} style={style}/>
            )
      }
    </div>
  )
};

const Memo = memo(PriceChart);
export default Memo;
